import React from "react";
import { motion } from "framer-motion";

const ButWhyEmphasisSlide = () => {
  return (
    <div className="h-full w-full bg-gradient-to-br from-blue-600 to-indigo-600 flex flex-col items-center justify-center text-white relative overflow-hidden">
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff15_1px,transparent_1px),linear-gradient(to_bottom,#ffffff15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />

      {/* Floating particles */}
      {[...Array(10)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1.5 h-1.5 bg-blue-200 rounded-full blur-[1px]"
          animate={{
            y: [0, Math.random() * -120],
            opacity: [0, 0.7, 0],
          }}
          transition={{
            duration: Math.random() * 4 + 3,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
        />
      ))}

      {/* Animated gradient orbs */}
      <motion.div
        animate={{
          y: [0, -30, 0],
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.55, 0.3],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute top-[-10%] left-[-10%] w-[520px] h-[520px] bg-blue-400 rounded-full blur-[120px] opacity-30 mix-blend-overlay"
      />
      <motion.div
        animate={{
          y: [0, 40, 0],
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1,
        }}
        className="absolute bottom-[-10%] right-[-10%] w-[620px] h-[620px] bg-indigo-400 rounded-full blur-[140px] opacity-30 mix-blend-overlay"
      />
      <motion.div
        animate={{
          x: [0, 30, 0],
          scale: [1, 1.15, 1],
          opacity: [0.25, 0.5, 0.25],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2,
        }}
        className="absolute top-[30%] right-[-5%] w-[380px] h-[380px] bg-sky-300 rounded-full blur-[120px] opacity-30 mix-blend-overlay"
      />

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-center px-8 z-10 relative"
      >
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-[11px] md:text-xs font-bold uppercase tracking-[0.4em] text-blue-100/80 mb-8"
        >
          The question worth asking
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="text-[120px] md:text-[180px] lg:text-[220px] font-black tracking-[-0.04em] leading-[0.9] bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-blue-200 drop-shadow-sm"
          style={{
            filter: "drop-shadow(0 0 40px rgba(191,219,254,0.35))",
          }}
        >
          But{" "}
          <motion.span
            animate={{
              filter: [
                "drop-shadow(0 0 30px rgba(191,219,254,0.5))",
                "drop-shadow(0 0 60px rgba(191,219,254,0.95))",
                "drop-shadow(0 0 30px rgba(191,219,254,0.5))",
              ],
            }}
            transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
            className="italic bg-clip-text text-transparent bg-gradient-to-b from-white via-blue-100 to-blue-300"
          >
            why?
          </motion.span>
        </motion.h1>

        {/* Animated underline */}
        <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 1, ease: "easeOut" }}
          className="mx-auto mt-10 h-[2px] w-[200px] origin-center"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.9) 50%, transparent 100%)",
          }}
        />
      </motion.div>

      {/* Soft moving shimmer */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.06) 50%, transparent 70%)",
        }}
        animate={{ x: ["-40%", "40%"] }}
        transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default ButWhyEmphasisSlide;
